export default "__VITE_ASSET__DYnhKnxe__"